module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/room-8035987ad9540a66041934e6d38da4ac.webp";